import { Col } from 'react-bootstrap';
import { Card, CardBody, Row } from 'reactstrap';
import CountUp from 'react-countup';
import React from 'react';

function BasicSnapshotCard({ title, value, icon, prefix, variant = 'primary' }) {
  return (
    <Col>
      <Card className="bg-light bg-opacity-30">
        <CardBody>
          <Row className="align-items-center">
            <Col>
              <h3 className="mb-2">
                <CountUp prefix={prefix} end={value} enableScrollSpy scrollSpyOnce />
              </h3>
              <h5 className="text-body-color mb-0" title={title}>
                {title}
              </h5>
            </Col>
            {icon && (
              <Col xs="auto">
                <div
                  className={`avatar-title bg-${variant} bg-opacity-10 text-${variant} rounded-circle fs-28 d-flex align-items-center justify-content-center`}
                  style={{ width: '45px', height: '45px', minWidth: '45px' }}
                >
                  {icon}
                </div>
              </Col>
            )}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
}

export default BasicSnapshotCard;
